import React from 'react';
import styled from 'styled-components';
import background from '../../assets/images/background.jpg';

const Wrapper = styled.div`
  background-color: ${({theme}) => theme.primaryColor};
  height: 100vh;
  padding: ${({theme}) => theme.spacingVertical(2)} 0 ${({theme}) => theme.spacingVertical(4)};
`;

const Content = styled.div`
  background-image: url(${background});
  background-color: #9b9cb2;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const Copyright = styled.span`
  position: absolute;
  right: ${({theme}) => theme.spacingHorizontal(2)};
  bottom: 7px;
  color: ${({theme}) => theme.white};
`;

export default ({children}) => (
  <Wrapper>
    <Content>{children}</Content>
    <Copyright>© Noventa Consulting AG</Copyright>
  </Wrapper>
);
